<template>
  <div>
    <header-page 
      :namePage="$t('overbooking.namePage')"
    />
    <loader v-if="isLoading" />
    <div v-else class="content">
      <div class="table__iteraction flex-between align-center">
        <span class="mk-current__attention"> {{$t('overbooking.table.informationTitle')}}: 
          <span class="mk-current__attention_bold">{{timezoneName}}</span>
        </span>
        <div class="flex">
          <button
            @click="cancelAllChanging"
            class="btn btn--transparent btn_cancel">
            {{$t('overbooking.button.cancel')}}
          </button>
          <button 
            @click="saveNewMatrixData"
            class="btn btn_success btn__save" 
            :disabled="!isDataChanged">
            {{$t('overbooking.button.save')}}
          </button>
        </div>
      </div>
      <base-table
        v-if="showTable"
        @copyDataToAllWeeks="copyDataToAllWeeks"
        :headHeightStatic="90"
        :isOverbooking="true"
        :matrixTable="true"
        :itemsCenter="true"
        :head="tableHead"
        :columnTemplates="columnSize">
        <div class="overbooking__time">
          <div 
            class="overbooking__cell"
            v-for="(time) of timePeriod" 
            :key="time.title">
            <div class="overbooking__cell_content">
              {{time.title}}
            </div>
          </div>
        </div>
        <div
          class="overbooking__statistic"
          v-for="(el, columnItem) of overbookingData"
          :key="columnItem">
          <div 
            class="overbooking__cell"
            v-for="(item, cellItem) of el.coefficients_for_hours" 
            :key="cellItem">
            <input 
              class="overbooking__input"
              v-if="item.correct" 
              type="number"
              v-model="item.overbooking_coefficient" 
              @input="changeCoefficient(item.overbooking_coefficient, columnItem, cellItem,)"
            />
            <div v-else class="overbooking__cell_content overbooking__cell_info" @click="callCoefficientInput(columnItem, cellItem, item.overbooking_coefficient)">
              {{item.overbooking_coefficient}}
            </div>
          </div>
        </div>
      </base-table>
    </div>
  </div>
</template>

<script>
import apiBooking from '@/api/master-classes/booking'
import {timePeriod} from '@/helpers/timeForSelect'
export default {
  data() {
    return {
      answer: null,
      compareCurrentDataOnCellCgange: {
        coefficient: null,
        position: {
          //column,
          //cell
        }
      },
      hoursUTCDifferent: 0,
      changeCeellCount: 0,
      isDataChanged: false,
      isCopyPressed: false,
      isLoading: true,
      showTable: true,
      timePeriod,
      startedOverbookingData: [],
      overbookingData: [],
      overbookingId: '',
      columnSize: 'repeat(8, 1fr)',
      tableHead: [
        this.$t('overbooking.table.titles.time'), 
        this.$t('overbooking.table.titles.daysOfWeek.monday'), 
        this.$t('overbooking.table.titles.daysOfWeek.tuesday'), 
        this.$t('overbooking.table.titles.daysOfWeek.wednesday'), 
        this.$t('overbooking.table.titles.daysOfWeek.thursday'), 
        this.$t('overbooking.table.titles.daysOfWeek.friday'), 
        this.$t('overbooking.table.titles.daysOfWeek.saturday'), 
        this.$t('overbooking.table.titles.daysOfWeek.sunday')
      ],
    }
  },
  async created() {
    let matrixResponse = await apiBooking.getOverbooking()
    let secondsInHour = 3600
    //разница с UTC в часах
    this.hoursUTCDifferent = this.$store.state.user.segment.tz_offset / secondsInHour
    this.overbookingData = matrixResponse.matrix
    this.overbookingId = matrixResponse.id
    this.overbookingData.forEach(el => {
      this.transformDataFromUTC(el)
      el.coefficients_for_hours.forEach(el => {
        el.correct = false
      })
    })
    this.startedOverbookingData = JSON.parse(JSON.stringify(this.overbookingData))
    this.isLoading = false
  },
  beforeRouteLeave (to, from, next) {
    if (this.answer) {
      next()
      return
    }
    if (this.isDataChanged) {
      this.answer = window.confirm(this.$t('overbooking.confirm'))
      if (!this.answer) return false
      else next()
    }
    if (!this.isDataChanged) next()
  },
  methods: {
    beforeUnloadListener (event) {
      event.preventDefault();
      return event.returnValue = "Are you sure you want to exit?";
    },
    transformDataFromUTC(el) {
      //Если tz_offcet положительный
      if (this.hoursUTCDifferent > 0) {
        //Удаляем с конца колличетво элментов ,равное разнице часов с UTC
        let reomovedItems = el.coefficients_for_hours.splice(-this.hoursUTCDifferent, this.hoursUTCDifferent)
        //Добавляем элементы начало массива начиная с 00:00
        el.coefficients_for_hours.splice(0, 0, ...reomovedItems)
        //Если tz_offcet отрицательный
      } else if (this.hoursUTCDifferent < 0) {
        //Удаляем с начала колличетво элментов равное разнице часов с UTC
        let reomovedItems = el.coefficients_for_hours.splice(0, Math.abs(this.hoursUTCDifferent))
        //Добавляем элементы в конец массива
        el.coefficients_for_hours.splice(el.coefficients_for_hours.length, 0, ...reomovedItems)
      }
    },
    cancelAllChanging() {
      if (this.compareCurrentDataOnCellCgange.coefficient) {
        this.overbookingData = this.startedOverbookingData
        this.overbookingData[this.compareCurrentDataOnCellCgange.position.column].coefficients_for_hours[this.compareCurrentDataOnCellCgange.position.cell].correct = false
      }
      this.nullCompareData()
      this.isCopyPressed = false
    },
    async copyDataToAllWeeks(columnIndex) {
      this.overbookingData.forEach((el, i) => {
        const targetDayOfWeek = JSON.parse(JSON.stringify(this.overbookingData[columnIndex - 1].coefficients_for_hours))
        if (i !== columnIndex - 1) el.coefficients_for_hours = targetDayOfWeek
        el.coefficients_for_hours.forEach(el => el.correct = false)
      })
      if (this.compareCurrentDataOnCellCgange.position.column && this.compareCurrentDataOnCellCgange.position.cell) {
        this.overbookingData[this.compareCurrentDataOnCellCgange.position.column].coefficients_for_hours[this.compareCurrentDataOnCellCgange.position.cell].correct = true
      }
      this.isDataChanged = true
      this.$store.commit('booking/setDataOnMatrixTable', this.isDataChanged)
      this.isCopyPressed = true
    },
    async saveNewMatrixData() {
      this.overbookingData.forEach(el => {
        if (this.hoursUTCDifferent > 0) {
          let changeItems = el.coefficients_for_hours.splice(0, this.hoursUTCDifferent)
          el.coefficients_for_hours.splice(el.coefficients_for_hours.length, 0, ...changeItems)
        } else if (this.hoursUTCDifferent < 0) {
          let changeItems = el.coefficients_for_hours.splice(this.hoursUTCDifferent, Math.abs(this.hoursUTCDifferent))
          el.coefficients_for_hours.splice(0, 0, ...changeItems)
        }
        el.coefficients_for_hours.forEach(el => {
          delete el.correct
        })
      })
      let sendObject = {
        segment: this.$store.state.user.segment.id,
        matrix: this.overbookingData
      }
      this.isLoading = true
      await apiBooking.changeMatrixData(sendObject, this.overbookingId)
      this.nullCompareData()
      this.rerenderTable(true)
    },
    changeCoefficient(newValue) {
      if (!this.isCopyPressed) {
       if (+this.compareCurrentDataOnCellCgange.coefficient !== +newValue ) {
         this.isDataChanged = true
         this.$store.commit('booking/setDataOnMatrixTable', this.isDataChanged)
       }
       else {
          if (this.changeCeellCount === 1) {
            this.isDataChanged = false
            this.$store.commit('booking/setDataOnMatrixTable', this.isDataChanged)
          } 
       }
      }
    },
    callCoefficientInput(columnItem, cellItem, currentCoefficient) {
      this.changeCeellCount++
      this.compareCurrentDataOnCellCgange.coefficient = currentCoefficient
      this.compareCurrentDataOnCellCgange.position.column = columnItem
      this.compareCurrentDataOnCellCgange.position.cell = cellItem
      this.overbookingData.forEach(el => {
        el.coefficients_for_hours.forEach(el => {
          el.correct = false
        })
      })
      this.overbookingData[columnItem].coefficients_for_hours[cellItem].correct = true
      this.rerenderTable()
    },
    rerenderTable(transformDataToShowOnTAble) {
      if (transformDataToShowOnTAble) {
        this.overbookingData.forEach(el => {
          this.transformDataFromUTC(el)
        })
      }
      this.showTable = false
      this.$nextTick(() => this.showTable = true)
      if (transformDataToShowOnTAble) this.isLoading = false
    },
    nullCompareData() {
      this.isDataChanged = false
      this.$store.commit('booking/setDataOnMatrixTable', this.isDataChanged)
      this.compareCurrentDataOnCellCgange.coefficient = null
      delete this.compareCurrentDataOnCellCgange.position.cell
      delete this.compareCurrentDataOnCellCgange.position.column
    }
  },
  computed: {
    timezoneName() {
      return this.$store.state.user.segment.timezone_name
    },
  },
  watch: {
    isDataChanged(val) {
      val ? 
        window.addEventListener("beforeunload", this.beforeUnloadListener) : 
        window.removeEventListener("beforeunload", this.beforeUnloadListener)
    }
  }
}
</script>

<style scoped lang="scss">
.btn__save {
  margin: 0 20px;
}
.overbooking {
  &__cell {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    border-bottom: 2px solid #EEEFF4;
    &_info {
      width: 60%;
      cursor: pointer;
    }
    &_content {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
    }
  }
  &__input {
    text-align: center;
    height: 40px;
    width: 60%;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
}
</style>